import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_langs_must_be_spoken_by_supvs_and_mgmt_in_order_to_eff'

export const dataPointDefinition = {
  retracedId: 'how_many_langs_must_be_spoken_by_supvs_and_mgmt_in_order_to_eff',
  name: 'How many languages must be spoken by supervisors and management in order to effectively communicate with ALL workers? ',
  description:
    "This question relates to workers and supervisors, and includes the language(s) used by local workers and supervisors, as well as all languages used by foreign or domestic migrant workers. \r\r\n\r\r\nConsider all languages used by workers and supervisors to communicate with each other while at work. This means you need to identify how many languages must be spoken by supervisors and management in order to effectively communicate with ALL workers.\r\r\n\r\r\nWorkers are persons working on/with the facility's product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them.\r\r\n\r\r\nSupervisors are persons who lead or supervise others and who work on the production floor (not in the office), e.g., line leaders, group leaders, and department heads, but not managers.",
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-lan-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 2050,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
